module.exports = __webpack_public_path__ + "static/media/aboutBanner3.3724e8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutBanner3.jpg
// module id = 352
// module chunks = 0